export default __webpack_public_path__ + "static/media/apn-news.925b3a1d.png";